
const digest = '0367229b9be681b885dd05c99ed59d79f54ee1c913d57e4bdcc82ac0d5a6c88b';
const classes = {"wrapper":"_wrapper_1h5hq_1","title":"_title_1h5hq_8"};
const css = `._wrapper_1h5hq_1 {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #eaedf3;
  height: 100%;
  overflow-y: auto;
}
._wrapper_1h5hq_1 ._title_1h5hq_8 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  